import React, {Component} from 'react';
import {connect} from 'react-redux';
import config from './../../config';

class JerseyManageTeamSummary extends Component {
    render() {
        let player = this.props.player;
        let inPlayerSkill = player.details.Skill;
        let inPlayerSkillAbbr = this.props.trans['short' + inPlayerSkill];
        let inPlayerName = player.details.PDName;
        let inPlayerJersey = config.playerImgBase + `player-jersey/${(player.details.Skill === 1) ? 'GK/' : ''}${player.details['TID']}.png`;
        let outPlayerSkill = player.DBDetails.Skill;
        let outPlayerSkillAbbr = this.props.trans['short' + outPlayerSkill];
        let outPlayerName = player.DBDetails.PDName;
        let outPlayerJersey = config.playerImgBase + `player-jersey/${(player.DBDetails.Skill === 1) ? 'GK/' : ''}${player.DBDetails['TID']}.png`;
        return <div className="si-details-row">
            <div className="si-plyr-wrap si-selected">
                <div className="si-data-wrap">
                    <span className="si-img-wrap" style={{backgroundImage: "url(" + outPlayerJersey + ")"}}/>
                    <div className="si-plyr-pos">{outPlayerSkillAbbr}</div>
                    <div className="si-plyr-details si-selected">
                        <span className="si-plyr-name">{outPlayerName}</span>
                    </div>
                </div>
            </div>
            <div className="si-transfer-icon">
                <i className="icon-ucl-transfers"/>
            </div>
            <div className="si-plyr-wrap si-selected">
                <div className="si-data-wrap">
                    <span className="si-img-wrap" style={{backgroundImage: "url(" + inPlayerJersey + ")"}}/>
                    <div className="si-plyr-pos">{inPlayerSkillAbbr}</div>
                    <div className="si-plyr-details si-selected">
                        <span className="si-plyr-name si-plyr-in">{inPlayerName}</span>
                    </div>
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(JerseyManageTeamSummary);


// WEBPACK FOOTER //
// ./src/components/manage-team/Jersey-Manage-Team-Summary.js